import React, { useState, useEffect } from 'react';
import styled, { keyframes, css } from 'styled-components';
// Удален неиспользуемый импорт telegramIcon

// Анимация пульсации
const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 153, 102, 0.7);
  }
  
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 15px rgba(255, 153, 102, 0);
  }
  
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 153, 102, 0);
  }
`;

// Анимация для привлекающего внимания текста
const bounceAnimation = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
`;

// Анимация появления
const fadeInAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Анимация для уведомления
const slideInAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const WidgetContainer = styled.div`
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 15px;
  animation: ${fadeInAnimation} 0.5s ease-out;
  
  @media (max-width: 768px) {
    bottom: 20px;
    right: 20px;
  }
  
  @media (max-width: 480px) {
    bottom: 15px;
    right: 15px;
  }
`;

const NotificationBubble = styled.div`
  background: white;
  padding: 12px 20px;
  border-radius: 25px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  font-size: 15px;
  font-weight: 500;
  color: #333;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
  animation: ${slideInAnimation} 0.5s ease-out;
  border: 1px solid rgba(255, 153, 102, 0.3);
  
  ${props => props.$isVisible && css`
    animation: ${bounceAnimation} 2s infinite;
  `}
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 25px rgba(0, 0, 0, 0.2);
  }
  
  &::after {
    content: '';
    position: absolute;
    right: -8px;
    bottom: 8px;
    width: 0;
    height: 0;
    border-left: 10px solid white;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
  }
  
  @media (max-width: 480px) {
    padding: 8px 15px;
    font-size: 13px;
    max-width: 200px;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #999;
  color: white;
  border: 2px solid white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s ease;
  opacity: 0;
  
  ${NotificationBubble}:hover & {
    opacity: 1;
  }
  
  &:hover {
    background: #666;
    transform: scale(1.1);
  }
`;

const BotButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  background: linear-gradient(135deg, #FF9966 0%, #FF5E62 100%);
  box-shadow: 0 8px 25px rgba(255, 94, 98, 0.4);
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  position: relative;
  animation: ${pulseAnimation} 2s infinite;
  
  &:hover {
    transform: scale(1.1);
    box-shadow: 0 12px 30px rgba(255, 94, 98, 0.6);
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  @media (max-width: 480px) {
    width: 55px;
    height: 55px;
  }
`;

// Удален неиспользуемый компонент BotIcon

const OnlineIndicator = styled.div`
  position: absolute;
  bottom: 4px;
  right: 4px;
  width: 14px;
  height: 14px;
  background: #4CAF50;
  border-radius: 50%;
  border: 2px solid white;
  animation: ${pulseAnimation} 2s infinite;
  
  @media (max-width: 480px) {
    width: 12px;
    height: 12px;
  }
`;

// SVG иконка Telegram
const TelegramSVG = () => (
  <svg width="35" height="35" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.161c-.18 1.897-.962 6.502-1.359 8.627-.168.9-.5 1.201-.82 1.23-.697.064-1.226-.46-1.901-.903-1.056-.692-1.653-1.123-2.678-1.799-1.185-.781-.417-1.21.258-1.911.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212-.07-.063-.173-.041-.248-.024-.106.024-1.793 1.139-5.062 3.345-.479.329-.913.489-1.302.481-.428-.009-1.252-.242-1.865-.442-.751-.244-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635.099-.002.321.023.465.141.145.118.181.28.199.39.018.11.038.355.021.548z"/>
  </svg>
);

const TelegramBotWidget = () => {
  const [showNotification, setShowNotification] = useState(true);
  const [notificationText, setNotificationText] = useState('Есть вопросы? Напишите нам в Telegram!');
  const TELEGRAM_BOT_URL = 'https://t.me/MaximumTravelBot';

  useEffect(() => {
    // Показываем разные сообщения с интервалом
    const messages = [
      'Есть вопросы? Напишите нам в Telegram!',
      'Узнайте о горячих турах первыми 🔥',
      'Получите консультацию эксперта 💬',
      'Подпишитесь на рассылку новостей 📰',
      'Поможем подобрать идеальный тур 🏝️'
    ];
    
    let messageIndex = 0;
    
    const interval = setInterval(() => {
      messageIndex = (messageIndex + 1) % messages.length;
      setNotificationText(messages[messageIndex]);
      setShowNotification(true);
      
      // Скрываем уведомление через 5 секунд
      setTimeout(() => {
        setShowNotification(false);
      }, 5000);
    }, 8000);
    
    // Показываем первое уведомление через 3 секунды после загрузки
    const timeout1 = setTimeout(() => {
      setShowNotification(true);
    }, 3000);
    
    // Скрываем через 8 секунд
    const timeout2 = setTimeout(() => {
      setShowNotification(false);
    }, 8000);
    
    return () => {
      clearInterval(interval);
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    };
  }, []);

  return (
    <WidgetContainer>
      {showNotification && (
        <NotificationBubble 
          $isVisible={showNotification}
          onClick={() => window.open(TELEGRAM_BOT_URL, '_blank')}
        >
          {notificationText}
          <CloseButton 
            onClick={(e) => {
              e.stopPropagation();
              setShowNotification(false);
            }}
          >
            ×
          </CloseButton>
        </NotificationBubble>
      )}
      
      <BotButton 
        href={TELEGRAM_BOT_URL}
        target="_blank"
        rel="noopener noreferrer"
        title="Написать в Telegram"
      >
        <TelegramSVG />
        <OnlineIndicator />
      </BotButton>
    </WidgetContainer>
  );
};

export default TelegramBotWidget;
